export default __webpack_public_path__ + "static/media/certify2.1f983c55.svg";